var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "form-horizontal form", attrs: { role: "form" } },
    [
      _c("div", { staticClass: "form-body" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-sm-3 control-label" }, [
            _vm._v("分组")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-8" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.gid,
                    expression: "gid"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.gid = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "0" } }, [_vm._v("未分组")]),
                _vm._v(" "),
                _vm._l(_vm.groups, function(g) {
                  return [
                    _c("option", { key: g, domProps: { value: g.objectId } }, [
                      _vm._v(_vm._s(g.title))
                    ])
                  ]
                })
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c("c-file-upload", {
                attrs: { config: _vm.cover },
                on: {
                  "update:config": function($event) {
                    _vm.cover = $event
                  }
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-sm-3 control-label" }, [
            _vm._v("描述")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.title,
                  expression: "title"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.title = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-actions" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-offset-3 col-sm-8" }, [
            _c(
              "button",
              {
                staticClass: "btn green",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.submit()
                  }
                }
              },
              [_vm._v("\n          保存\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn grey-salsa btn-outline",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.cancel()
                  }
                }
              },
              [_vm._v("\n          取消\n        ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "control-label col-sm-3" }, [
      _vm._v("图片\n        "),
      _c("span", { staticClass: "required" }, [_vm._v(" * ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }